export const environment = {
  production: true,
  googleSheetsApiKey: 'AIzaSyA-zvGnfBhsu48lRZqplCiMJyAHqnutMLU',
  document: {
    spreadsheetId: '18soz9NSRTZ9KIAhR6Z7ozG3Q_CyeB-85NoaoIB6qavA',
    worksheetName: 'mooc',
  },
};
